module.exports = __webpack_public_path__ + "img/89eda83.jpg";